import { useState } from 'react'
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import IconButton from '../../../components/IconButton/IconButton'

export default function CommentForm({ onSubmit }) {
    const [text, setText] = useState('')
    return (
      <form
        className="hold-composer hold-composer--compact"
        onSubmit={(event) => {
          event.preventDefault()
          if (!text.trim()) return
          onSubmit(text)
          setText('')
        }}
      >
        <input value={text} onChange={(event) => setText(event.target.value)} placeholder="Skriv en kommentar" />
        <IconButton 
            type="submit" 
            variant="outlined"
            icon={<SendRoundedIcon fontSize="small" />} 
          disabled={!text.trim()}
        />
      </form>
    )
  }